import { useEffect, useState } from "react";
import { Phone, Mail } from "lucide-react";
import { useApi, fmtDateTime } from "@/lib/api";
import { PageHeader, Empty, StatusBadge } from "@/components/portal/StatusBadge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const SERVICE = { custom_home: "Custom home", concrete: "Concrete work", other: "Other" };

export default function Leads() {
  const api = useApi();
  const [leads, setLeads] = useState(null);
  useEffect(() => {
    api("get", "/leads").then(setLeads);
  }, [api]);

  const setStatus = async (l, status) => {
    await api("patch", `/leads/${l.id}`, { status });
    setLeads(leads.map((x) => (x.id === l.id ? { ...x, status } : x)));
  };

  return (
    <div data-testid="leads-page">
      <PageHeader eyebrow="Website inbox" title="Estimate requests" />
      {leads && !leads.length && <Empty text="No requests yet. New ones from the website form will land here." />}
      <div className="grid gap-4 md:grid-cols-2">
        {leads?.map((l) => (
          <div key={l.id} className="rounded-xl border border-[#E6E2DA] bg-white p-5" data-testid={`lead-card-${l.id}`}>
            <div className="flex items-start justify-between gap-3">
              <div><p className="font-display text-lg font-bold">{l.name}</p><p className="text-xs text-[#8C877D]">{SERVICE[l.service]}{l.city ? ` · ${l.city}` : ""} · {fmtDateTime(l.created_at)}</p></div>
              <StatusBadge status={l.status} testId={`lead-status-${l.id}`} />
            </div>
            {l.message && <p className="mt-3 whitespace-pre-wrap text-sm text-[#4A4742]">{l.message}</p>}
            <div className="mt-4 flex flex-wrap items-center gap-4 text-sm">
              <a href={`mailto:${l.email}`} className="flex items-center gap-1 font-medium hover:text-[#A67C00]"><Mail size={14} />{l.email}</a>
              {l.phone && <a href={`tel:${l.phone}`} className="flex items-center gap-1 font-medium hover:text-[#A67C00]"><Phone size={14} />{l.phone}</a>}
              <div className="ml-auto w-36">
                <Select value={l.status} onValueChange={(v) => setStatus(l, v)}>
                  <SelectTrigger data-testid={`lead-status-select-${l.id}`}><SelectValue /></SelectTrigger>
                  <SelectContent>{["new", "contacted", "won", "lost"].map((s) => <SelectItem key={s} value={s} className="capitalize">{s}</SelectItem>)}</SelectContent>
                </Select>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
